export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6759.2b8fc152.jpg";